import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../../common/automation-display.service';
import { Injectable } from '@angular/core';
import { WORKFLOW_TRIGGERS } from '../../../../component-loader/trigger-definitions';
import { CRMCustomObjectCreatedOrModified } from '../../../../component-loader/constants';
import { CrmCreatedModifiedSelectorService } from '../../crm-common/crm-created-modified-selector/crm-created-modified-selector.service';
@Injectable({
  providedIn: 'root',
})
export class CrmCustomObjectCreatedModifiedService extends AutomationDisplayService {
  constructor(
    protected readonly translateService: TranslateService,
    protected readonly crmCreatedModifiedSelectorService: CrmCreatedModifiedSelectorService,
  ) {
    super();
  }

  getAutomationNodeData(
    _namespace: string,
    step: WorkflowStepInterface,
    isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    let key: string;
    if (isWaitUntilNode) {
      key = WORKFLOW_TRIGGERS[CRMCustomObjectCreatedOrModified].waitUntilNodeDisplay || '';
    } else {
      key = WORKFLOW_TRIGGERS[CRMCustomObjectCreatedOrModified].nodeDisplay || '';
    }

    const actionString = this.crmCreatedModifiedSelectorService.findActionString(step?.choices?.rules?.[0]);
    return this.nodeDisplayData(
      this.translateService.stream(key, {
        action: actionString,
      }),
      this.noValidationErrorsDetected(),
    );
  }

  getActivityColumn(_namespace: string, activity: ActivityInterface): ActivityTableEntry {
    let key: string;
    if (activity.workflowStep?.waitForTriggerTaskDefinitionId) {
      key = WORKFLOW_TRIGGERS[CRMCustomObjectCreatedOrModified].waitUntilNodeDisplay || '';
    } else {
      key = WORKFLOW_TRIGGERS[CRMCustomObjectCreatedOrModified].activityDisplay || '';
    }

    const actionString = this.crmCreatedModifiedSelectorService.findActionString(
      activity.workflowStep?.choices?.rules?.[0],
    );
    return this.triggerActivityEntry(
      this.translateService.stream(key, {
        action: actionString,
      }),
    );
  }
}
